// export default function (data) {
//   data.dataList.sort((a, b) => b.dataValue - a.dataValue)
//   return {
//     chart: {
//       type: 'bar',
//       backgroundColor: 'rgba(0,0,0,0)'
//     },
//     title: {
//       text: '最受欢迎菜品',
//       style: {
//         color: '#ffffff',
//         fontSize: '14px',
//         lineHeight: '20px'
//       }
//     },
//     subtitle: {
//       text: ''
//     },
//     xAxis: {
//       categories: data.dataList.map(item => item.dataSubCodeName),
//       labels: {
//         style: {
//           color: '#ffffff',
//           fontSize: '9px'
//         }
//       }
//     },
//     yAxis: {
//       min: 0,
//       gridLineWidth: 0,
//       title: {
//         text: '',
//         align: 'high'
//       },
//       labels: {
//         enabled: false
//       }
//     },
//     tooltip: {
//       valueSuffix: ''
//     },
//     plotOptions: {
//       bar: {
//         dataLabels: {
//           enabled: false
//         }
//       }
//     },
//     legend: {
//       enabled: false
//     },
//     credits: {
//       enabled: false
//     },
//     series: [
//       {
//         name: '',
//         data: data.dataList.map(item => item.dataValue)
//       }
//     ]
//   }
// }
export default function (data) {
  // data.dataList.sort((a, b) => b.dataValue - a.dataValue)
  return {
    colors: ['#59abff'],
    chart: {
      backgroundColor: 'rgba(0,0,0,0)',
      type: 'column',
      margin: [10,10,50,10],
      options3d: {
        enabled: true,
        alpha: 10,
        beta: 15,
        depth: 30,
        viewDistance: 50, 
        frame: {
          bottom: {
            size: 10
          },
          side: {
            size: 1,
            color: 'transparent'
          },
          back: {
            size: 1,
            color: 'transparent'
          }
        }
      },
    },
    title: {
      text: '最受欢迎菜品',
      style: {
        color: '#ffffff',
        fontSize: '14px',
        lineHeight: '20px'
      }
    },
    subtitle: {
      text: ''
    },
    plotOptions: {
      column: {
        depth: 15
      }
    },
    xAxis: {
      categories: data.dataList.map(item => item.dataSubCodeName),
      labels: {
        style: {
          color: '#ffffff',
          fontSize: '10px'
        }
      },
      gridLineWidth: 0// 横向格线宽度
    },
    yAxis: {
      title: {
        text: null
      },
      labels: {
        style: {
          color: '#ffffff',
          fontSize: '7px'
        }
      },
      gridLineWidth: 0// 横向格线宽度
    },
    legend: {
      enabled: false
    },
    series: [{
      name: '数量',
      data: data.dataList.map(item => item.dataValue)
    }],
    credits: {
      enabled: false
    }
  }
}

